import { render, staticRenderFns } from "./DichVuChatLuongCaoForm.vue?vue&type=template&id=d6967b3c&"
import script from "./DichVuChatLuongCaoForm.vue?vue&type=script&lang=js&"
export * from "./DichVuChatLuongCaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports